import React from 'react';
import iconErrorCard from './images/icon-100-errorcard@3x.svg';
import iconError from './images/icon-120-error@3x.svg';
import whatsAppIcon from './images/WhatsApp@3x.svg'

const Error = (props) => {
    let iconImage = "";

    switch (props.iconType) {
        case "error":
            iconImage = iconError;
            break;
        case "errorPayment":
            iconImage = iconErrorCard;
            break;
        case "whatsapp":
            iconImage = whatsAppIcon;
            break;
    }


    return (
        <div className='moving-apartment-error-page'>
            <div className='icon' style={{ backgroundImage: "url(" + iconImage + ")" }}></div>
            <div className='title'>{props.title}</div>
            <div className='subtitle'>{props.subTitle}</div>
            {props.isDisplayServiceCall &&
                <div className='service-call-wrapper'>
                    <div className='text'>נשמח לעזור בכל שאלה</div>
                    <a className='phone' href={'tel:*'+ window.Config.technicalSupportPhone}>חייגו {window.Config.technicalSupportPhone} לנציג שירות</a>
                </div>
            }
            {(props.hasDebt || props.hasPaymentMethodIssue) &&
                <div className='financially-issue-wrapper'>
                    {props.hasDebt && <a href='#' target="_blank" onClick={() => props.onClickDebtPaymentLink()} >לתשלום חוב</a>}
                    {props.hasPaymentMethodIssue && <a href='#' target="_blank" onClick={() => props.onClickUpdatePaymentLink()} >לעדכון אמצעי תשלום</a>}
                </div>
            }
        </div>

    );
};
export default Error;
